import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import SampleProducts from "../../components/SampleProducts";
import "./ReadymadeTechs.css";

export default function ReadymadeTechs() {

  const navigate = useNavigate();
  const { t1, t2 } = useParams();

 const remainingProducts =
  SampleProducts.filter(product => !product.featured);


  const goToProduct = (id) => {
    navigate(`/business-product/${t1}/${t2}/${id}`);
  };

  return (
    <div className="readymade-page">

    <div className="readymade-header">
      {/* ✅ Back Button */}
      <button
        className="readymade-back-btn"
        onClick={() => navigate(`/mind-mapping/sec-b/${t1}/${t2}`)}
      >
        <FaArrowLeft />
      </button>

      <h1 className="readymade-title">
        Ready Made Tech's
      </h1>
      </div>

      {/* ✅ BULLET LIST */}
      <ul className="readymade-list">
        {remainingProducts.map((product) => (
          <li
            key={product.id}
            onClick={() => goToProduct(product.id)}
          >
            {product.name}
          </li>
        ))}
      </ul>

    </div>
  );
}
